import axiosPost from "./axiosPost";

export const MerchantBORAUpd= async (credentials, data, location) => {
    const body = {
        service: "MerchantBORAUpd",
        params: {
            merchantId: data.merchantId,
            estadoRegistroCod: data.estadoRegistroCod,
            registroLatitud: location.latitud,
            registroLongitud: location.longitud,
        },
    };    
    try {
        
        const response = await axiosPost("Y", body, credentials)
        return response;
    } catch (err) {
        console.error(`Error: ${err}`);
    }
}